import toastStore from './toastStore';

const makeToast = (toast) => {
  toastStore.add(toast);
};

export default makeToast;
